export default __webpack_public_path__ + "static/media/Mark-3-Suit-05.8f255f41.jpg";